import { faFile } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Text } from '@modusign/design-system';
import moment from 'moment';

import matchSearchString from '@app/libs/matchSearchString';

interface DocumentNameProps {
  title: string;
  participantNames: string[];
  searchString: string;
  updatedAt?: string;
  hideIconInMobile?: boolean;
}

export default function DocumentName({
  title,
  participantNames,
  searchString,
  updatedAt,
  hideIconInMobile,
}: DocumentNameProps) {
  return (
    <Flex alignItems="center" px={4} py={2}>
      <Flex
        alignItems="center"
        color="textNeutralLight"
        display={hideIconInMobile ? ['none', null, 'flex'] : undefined}
        flex="none"
        fontSize="13px"
        height="16px"
        justifyContent="center"
        width="16px"
      >
        <FontAwesomeIcon icon={faFile} />
      </Flex>
      <Box ml={hideIconInMobile ? [0, null, 3] : 3}>
        <Text
          display="block"
          sx={{
            em: {
              fontStyle: 'normal',
              fontWeight: 'bold',
            },
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
        >
          {matchSearchString(title, searchString).map(({ match, content }) =>
            match ? <em key={content}>{content}</em> : content
          )}
        </Text>
        <Text
          color="textNeutralLight"
          display="block"
          fontSize="sm"
          sx={{
            em: {
              fontStyle: 'normal',
              fontWeight: 'bold',
            },
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
        >
          {participantNames.length
            ? matchSearchString(participantNames.join(', '), searchString).map(
                ({ match, content }) => (match ? <em key={content}>{content}</em> : content)
              )
            : '-'}
        </Text>
        {updatedAt && (
          <Text color="textNeutralVeryLight" display={['block', null, 'none']} mt={1}>
            {moment(updatedAt).format('YYYY.MM.DD A hh:mm')}
          </Text>
        )}
      </Box>
    </Flex>
  );
}
